import { render, staticRenderFns } from "./ScrollBoxRadio.vue?vue&type=template&id=2eb1318a&"
import script from "./ScrollBoxRadio.vue?vue&type=script&lang=js&"
export * from "./ScrollBoxRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports